import * as Collapsible from '@radix-ui/react-collapsible'

import ChevronLargeDownIcon from '@/assets/icons/chevron-large-down.svg?react'
import {
  CurriculumTimeUnitTag,
  type CurriculumTimeUnit
} from '@/modules/curriculumsManagement'

import styles from './CourseCollapsible.module.scss'

type CourseCollapsibleProps = {
  title: string
  timeUnit: CurriculumTimeUnit
  children: React.ReactNode
} & Omit<Collapsible.CollapsibleProps, 'children' | 'title'>

const CourseCollapsible = (props: CourseCollapsibleProps) => {
  const { title, timeUnit, children, ...collapsibleProps } = props

  return (
    <Collapsible.Root className={styles.container} {...collapsibleProps}>
      <Collapsible.Trigger className={styles.header}>
        <ChevronLargeDownIcon aria-hidden="true" className={styles.icon} />

        <span className={styles.title}>{title}</span>
        <CurriculumTimeUnitTag timeUnit={timeUnit} />
      </Collapsible.Trigger>
      <Collapsible.Content className={styles.content}>
        <div className={styles.contentBox}>{children}</div>
      </Collapsible.Content>
    </Collapsible.Root>
  )
}

export default CourseCollapsible
